export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-array/src/constant.js
// module id = PZ6Z
// module chunks = 0